import { Circle } from 'react-leaflet'

interface HandoffCircleProps {
  center: {
    lat: number
    lng: number
  }
}

export function HandoffCircle({ center }: HandoffCircleProps) {
  // 20 feet = approximately 6.096 meters
  const handoffRadius = 6.096

  return (
    <Circle
      center={[center.lat, center.lng]}
      radius={handoffRadius}
      fillColor="#f59e0b"
      fillOpacity={0.3}
      color="#f59e0b"
      weight={2}
      dashArray="4, 4"
    />
  )
}
